import * as Sentry from '@sentry/react';

const SENSITIVE_KEY_PATTERN = /token|secret|password|authorization|apikey|api_key|email|phone|mobile|contact|owner|applicant/i;
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const SENTRY_ENVIRONMENT = process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV;
const SENTRY_RELEASE = process.env.REACT_APP_SENTRY_RELEASE
  || process.env.REACT_APP_VERCEL_GIT_COMMIT_SHA
  || process.env.REACT_APP_GIT_SHA;

function scrubValue(value, depth = 0) {
  if (value === null || value === undefined) return value;
  if (depth > 3) return '[Truncated]';
  if (typeof value === 'string') return value.length > 500 ? `${value.slice(0, 500)}...` : value;
  if (typeof value === 'number' || typeof value === 'boolean') return value;
  if (Array.isArray(value)) return value.slice(0, 20).map(item => scrubValue(item, depth + 1));
  if (typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).slice(0, 50).map(([key, item]) => [
        key,
        SENSITIVE_KEY_PATTERN.test(key) ? '[Filtered]' : scrubValue(item, depth + 1),
      ])
    );
  }
  return '[Filtered]';
}

export function initSentry() {
  if (!SENTRY_DSN) return;

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: SENTRY_ENVIRONMENT,
    release: SENTRY_RELEASE,
    sendDefaultPii: false,
    tracesSampleRate: 0,
    beforeSend(event) {
      const requestUrl = event.request?.url;
      if (requestUrl) {
        try {
          const url = new URL(requestUrl);
          event.request.url = `${url.origin}${url.pathname}`;
          delete event.request.query_string;
        } catch {
          delete event.request.url;
          delete event.request.query_string;
        }
      }

      event.user = event.user ? { id: event.user.id } : undefined;
      event.extra = scrubValue(event.extra || {});
      event.contexts = scrubValue(event.contexts || {});
      event.tags = scrubValue(event.tags || {});

      if (event.breadcrumbs) {
        event.breadcrumbs = event.breadcrumbs.map(breadcrumb => ({
          ...breadcrumb,
          data: scrubValue(breadcrumb.data || {}),
          message: breadcrumb.message ? scrubValue(breadcrumb.message) : breadcrumb.message,
        }));
      }

      return event;
    },
  });
}

export { Sentry };
